'use strict';

var CommonValidatorFunctions = require('./CommonValidatorFunctions.cjs.js');

class KubernetesValidatorFunctions {
  static isValidApiVersion(value) {
    return CommonValidatorFunctions.CommonValidatorFunctions.isValidPrefixAndOrSuffix(
      value,
      "/",
      CommonValidatorFunctions.CommonValidatorFunctions.isValidDnsSubdomain,
      (n) => n.length >= 1 && n.length <= 63 && /^[a-z0-9A-Z]+$/.test(n)
    );
  }
  static isValidKind(value) {
    return typeof value === "string" && value.length >= 1 && value.length <= 63 && /^[a-zA-Z][a-z0-9A-Z]*$/.test(value);
  }
  static isValidObjectName(value) {
    return typeof value === "string" && value.length >= 1 && value.length <= 63 && /^([A-Za-z0-9][-A-Za-z0-9_.]*)?[A-Za-z0-9]$/.test(value);
  }
  static isValidNamespace(value) {
    return CommonValidatorFunctions.CommonValidatorFunctions.isValidDnsLabel(value);
  }
  static isValidLabelKey(value) {
    return CommonValidatorFunctions.CommonValidatorFunctions.isValidPrefixAndOrSuffix(
      value,
      "/",
      CommonValidatorFunctions.CommonValidatorFunctions.isValidDnsSubdomain,
      KubernetesValidatorFunctions.isValidObjectName
    );
  }
  static isValidLabelValue(value) {
    return value === "" || KubernetesValidatorFunctions.isValidObjectName(value);
  }
  static isValidAnnotationKey(value) {
    return CommonValidatorFunctions.CommonValidatorFunctions.isValidPrefixAndOrSuffix(
      value,
      "/",
      CommonValidatorFunctions.CommonValidatorFunctions.isValidDnsSubdomain,
      KubernetesValidatorFunctions.isValidObjectName
    );
  }
  static isValidAnnotationValue(value) {
    return typeof value === "string";
  }
}

exports.KubernetesValidatorFunctions = KubernetesValidatorFunctions;
//# sourceMappingURL=KubernetesValidatorFunctions.cjs.js.map
